// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subject[data-v-a163f72a]{background:#eee}.subject .container[data-v-a163f72a]{float:unset;width:1200px;margin:auto;height:40px;padding-top:12px}", ""]);
// Exports
module.exports = exports;
